import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
const WebView = ({ src, onLoad, onError }, ref) => (_jsx("iframe", { ref: ref, className: 'taro-webview', onLoad: event => {
        event.stopPropagation();
        onLoad === null || onLoad === void 0 ? void 0 : onLoad({ src });
    }, onError: event => {
        event.stopPropagation();
        onError === null || onError === void 0 ? void 0 : onError({ src });
    }, src: src }));
export default forwardRef(WebView);
